import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppButton } from "./Generic/AppButton";
import Scaffold from "./Scaffold/Scaffold";

interface Props {
  title: string;
  imagePreview: string;
  onClickDownload: () => void;
  onClickGoBack: () => void;
}

const DocumentDownloadScreen = (props: Props) => {
  return (
    <Scaffold title={props.title} onClickGoBack={props.onClickGoBack}>
      <DocumentDownloadScreen.Root>
        <DocumentDownloadScreen.Header onClick={props.onClickDownload}>
          <img src={props.imagePreview} />
        </DocumentDownloadScreen.Header>
        <AppButton onClick={props.onClickDownload}>{translate(STRINGS.DOWNLOAD_PDF)}</AppButton>
      </DocumentDownloadScreen.Root>
    </Scaffold>
  );
};

DocumentDownloadScreen.Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  img {
    width: 300px;
    border-radius: 10px;
  }
`;

DocumentDownloadScreen.Header = styled.div``;

export default DocumentDownloadScreen;
